<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">
          <div v-if="item.productType==2">
            <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
          </div>
          <div v-else class="contentDiv">
            <hotel-resource-left :productObj="item" :showTag="false" :btnName="'加入行程'" :btnName1="'询'" class="contentHead"
              @exclusiveAddYsP="exclusiveAddYsP(item)" @inquiryResource="inquiryResource">
            </hotel-resource-left>
          </div>
        </div>
      </template>
    </stock>
    <create-product-dialog ref="createProduct" :keyStr="keyStr" :searchDate="searchObj.date"></create-product-dialog>
  </div>
</template>

<script>
import Stock from './stock.vue'
import Api from '@/components/Api/index.js'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import CreateProductDialog from './addProductDialog/createProductDialog.vue'
import ExclusiveStock from './exclusiveStock.vue'
export default {
  components:{Stock,hotelResourceLeft,CreateProductDialog,ExclusiveStock},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:null,
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:7,
        planId:null,
      },
      dataList:[],
      keyStr:'',
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    inquiryResource(item){
      this.$Bus.$emit('openInquiryPage',item)
    },
    postListData(type){
      if(this.checkState===7){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      } 
    },
    exclusiveAddYsP(item){
      this.$refs.createProduct.beforeOpen(item,{productNameCn:''})
    }
  }
}
</script>

<style lang="scss" scoped>
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
}
</style>